import React from "react";
import { Theme } from "../models/models";
import { StorageContext } from "../components/storage/storage-context";

const About: React.FC<any> = (props: any) => {

  const [storageContext, setStorageContext] = React.useContext(StorageContext);
  
  const [theme, setTheme] = React.useState<Theme | undefined>(undefined);

  React.useEffect(() => setTheme(storageContext.theme as Theme), [storageContext.theme]);

  return (
    <div className="py-16 px-4 mx-auto diamonds">
      <div className="container py-16 min-h-screen">
        <h1 className="text-xl gold-text text-center align-middle inline-block ml-8 pb-8">
          &nbsp;&nbsp;About&nbsp;&nbsp;
        </h1>
        <div className="flex items-center content-center p-16  md:mx-16 ">
          <p className="rainbow-text">

            { theme && theme.about }

          {/* &nbsp;&nbsp;&nbsp;&nbsp;In the heart of Milwaukee's vibrant music scene, I found my calling and passion as a house music DJ. Growing up surrounded by the rhythm of the city, I was captivated by the pulsating beats that echoed through the streets. From the moment I first stepped into a dimly lit nightclub and felt the music reverberate through my soul, I knew I had discovered my truest form of expression.
          <br></br>
          &nbsp;&nbsp;&nbsp;&nbsp;My journey into the world of DJing started in the most unexpected way. As a teenager, I would spend hours exploring record stores, searching for that perfect beat that would ignite the dance floor. With each vinyl I collected, I honed my skills, learning the art of blending tracks seamlessly. The turntables became an extension of myself, allowing me to communicate my emotions and energy to the crowd. 
<br></br>
&nbsp;&nbsp;&nbsp;&nbsp;Milwaukee, with its diverse and passionate music lovers, became my canvas. I would spin at local clubs, from the underground gems to the mainstream venues, infusing every set with my unique style. My mixes were more than just a collection of tracks; they were a narrative, a journey that took the listeners on a sonic adventure. The city responded with open arms, embracing the fusion of classic house beats and innovative sounds that became my signature.
<br></br>
&nbsp;&nbsp;&nbsp;&nbsp;Being a female DJ in a male-dominated industry had its challenges, but it only fueled my determination. I wanted to break barriers, challenge stereotypes, and show the world that music knows no gender. Milwaukee became the backdrop for my story of resilience and passion. With every beat I dropped, I hoped to inspire others to follow their dreams fearlessly, regardless of societal expectations.
<br></br>
&nbsp;&nbsp;&nbsp;&nbsp;As the city's nightlife pulsed around me, I felt a deep connection to the community. Milwaukee wasn't just a city; it was a family of music enthusiasts, artists, and dreamers. Together, we created moments of pure euphoria on the dance floor, where the worries of the world faded, and all that remained was the music and the energy we shared. In those moments, I found my purpose – not just as a DJ, but as a storyteller, weaving narratives through melodies and rhythms, leaving a lasting impact on the souls that tuned into my beats.
           */}
          
          </p>
        </div>
      </div>

    </div>
  )
}

export default About;